var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 842 197",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.6 91c-10.2 0-18-2-24.6-8.7l8.5-8.5c4.3 4.3 10 5.7 16.3 5.7 7.7 0 12-3 12-8.3 0-2.4-.8-4.4-2.2-5.7-1.3-1.2-2.8-2-6-2.4l-8-1c-5.8-.8-10-2.6-13-5.5-3.3-3.3-5-7.6-5-13.2 0-12 9-20.4 23.5-20.4 9.4 0 16 2 22 7.7l-8.4 8.3c-4.3-4-9.4-4.7-13.8-4.7-7 0-10.5 4-10.5 8.5 0 1.7.6 3.5 2 4.8 1.3 1.2 3.5 2.3 6.2 2.6l8 1.2c6 .8 10 2.5 12.8 5 3.6 3.5 5.2 8.5 5.2 14.4 0 13-10.8 20.3-25 20.3zm62.8-56v55.5h-13V35h-17.7V23H351v12h-17.6zm60.1 55.5-4-12h-24l-4 12h-13.7l24.5-67.3h10.2L407 90.5h-13.5zM377.7 43l-8.4 24.6H386L377.7 43zm80.1 41c-4.4 4.6-10.8 6.6-17.7 6.6H416V23.2h24c7 0 13.4 2 17.8 6.5 7.6 7.6 7 16.8 7 27-.2 10 .5 20-7 27.4zm-9.2-45c-2.2-2.6-5.3-4-9.8-4h-10v44h10c4.5 0 7.6-1.5 9.8-4.2 2.5-3 3-8 3-18 0-10.4-.5-14.7-3-17.7zm54.1-4v55.5h-13V35H472V23h48.2v12h-17.5zM591 90.5h-11l-12.3-40.8-12.4 40.8h-11l-18-67.3h13.8l10.5 42.5 12.3-42.5h10L585 65.7l10.5-42.5h13.7L591 90.5zm26.8 0V23.2H662V35h-31v15.7h26.5v11.7H631v16.3h31v11.7h-44zm91.4 0-13-26.8h-9.5v26.8h-13.2V23.2H700c13.7 0 21.8 9.4 21.8 20.7 0 9.3-5.8 15.2-12.3 17.6l15 29h-15.3zM699 35h-12.3v17.7H699c5.8 0 9.6-3.7 9.6-8.8 0-5.4-3.8-9-9.6-9zm74.4 55.5L756 60l-8.7 10.3v20.3h-13V23.2h13v29.4L771 23.2h16L764.7 50l24 40.6h-15.3zm23.8 0V23.2h44.3V35h-31.2v15.7H837v11.7h-26.7v16.3h31.2v11.7h-44.3zM302.7 173h-6.3l-14-50.5-14 50.5h-6.2L246 110h7.2l12.3 50.8 14-50.8h6l13.8 50.8 12.3-50.8h7.2l-16 63zm26.7-63h6.8v63h-6.8zm43.1 6v57h-6.8v-57h-18.2v-6h43.2v6h-18.2zm51.5 0v57h-6.7v-57H399v-6h43.2v6H424zm29.5 57v-63h39v6h-32.3v22.2h27.6v6h-27.6V167h32.4v6h-39zm90.5 0-33.4-50.5V173H504v-63h6.3l33.4 50.3V110h6.8v63H544z",
    fill: "#0c2f6e",
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4 100.3c-9.3-11.3-18-24-22.6-38-4.2-12.7-4-26.4 1.2-38.8 3.6-9 8-15.3 15.2-23.4-22.8 5.8-45 21.3-52 44.5-8.7 30 11.7 57.8 25.4 82.8 4 7.4 7.6 15.6 7 24-.8 13.3-9 22.5-20.3 29 12.6 10.5 29.2 19.6 46 14.5 17.6-5.5 31.5-22.3 31-41-.3-9.5-4.7-18.4-10-26-6.8-9.2-14-18.3-21-27.5z",
    fill: "url(#logo_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 39.3C-5.5 72.5-6.2 120 15.5 155l6 9c2.3 3 2 3.3 5 2 7-2.7 13-10.8 13-18.5-.2-10.3-6.4-20.3-10.5-29.5l-6-13.4C14 85 8.5 59 19.7 39.3z",
    fill: "url(#logo_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 96c9.3 11.2 18 23.8 22.5 38 4.2 12.6 4 26.3-1.2 38.8-3.6 8.8-8 15.3-15.2 23.4 23-5.7 45.3-21.2 52-44.4 8.8-30-11.6-57.8-25.3-83-4-7.2-7.5-15.4-7-24 .8-13.2 9-22.4 20.3-28.8-12.6-10.5-29.2-19.7-46-14.5-17.6 5.5-31.5 22.3-31 41 .4 9.5 4.7 18.4 10 26l21 27.4z",
    fill: "url(#logo_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.6 157c25.2-33.2 25.8-80.6 4.2-115.7-1.8-3-4-6-6-9-2.3-2.8-2-3.3-5-2-7 2.8-13 11-13 18.5.3 10.3 6.4 20.3 10.5 29.5l6 13.4c8.8 19.7 14.4 45.5 3.3 65.3z",
    fill: "url(#logo_svg__d)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 132.488 63.773) scale(196.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009ee3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 93.217 73.498) scale(127.438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009ee3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 168.426 27.835) scale(196.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009ee3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 173.295 -16.292) scale(127.438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009ee3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134094"
  })))));
};

export default SvgLogo;